import { formatInvoiceMoney } from "@common/helpers/nativeInvoice";

// Shared money formatter for the native invoice drawer (document preview,
// details panel totals, etc.). Delegates to the common invoice money formatter
// so the live preview and the server-rendered PDF can never diverge. Native
// invoices are USD-only today.
export function formatMoney(amount: number): string {
    return formatInvoiceMoney(amount, "usd");
}
